import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectLanguage } from '../../redux/language/selector'
import { useTranslation } from 'react-i18next'
import Navbar from '../../components/Navbar'
import { TripleCustomBreadCrumbs } from '../../components/CustomBreadcrumbs'
import IndustriesStickyMenu from '../../components/IndustriesStickyMenu'
import IndustriesImageContainer from '../../components/IndustriesImageContainer'
import Footer from '../../components/Footer'
import account_statements_img1 from "../../assets/images/contents/account-statements-1.png"
import account_statements_img2 from "../../assets/images/contents/account-statements-2.png"
import { PrimaryButton } from '../../components/StyledButtons'
import filter_color from "../../assets/images/design/colorFilter.svg"
import ModalContactDiscussionForm from '../../components/ModalContactDiscussionForm'

const AccountStatements = () => {
    const { t } = useTranslation()

    const language = useSelector(selectLanguage)

    const [modalDiscussionOpen, setModalDiscussionOpen] = useState(false);
    const modalDiscussionRef = useRef(null);
    const handleOverlayClick = (event) => {
        if (modalDiscussionRef.current && !modalDiscussionRef.current.contains(event.target)) {
            setModalDiscussionOpen(false)
        }
    };
    document.onkeydown = function (evt) {
        if (evt.code === 'Escape') {
            setModalDiscussionOpen(false)
        }
    };

    return (
        <div className='account-statements bg-primary'>
            <div className='color-filter-right' style={{ top: "20%" }}>
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
            <div className='color-filter-left' >
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
            <div className='color-filter-left' style={{ top: "52%" }} >
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
            <Navbar />
            <div className='container-fluid account-statements-header pb-100'>
                <div className='container'>
                    {language === "en" ?
                        <div className='col-sm-12 pt-150'>
                            <div className='font-weight-bold text-center font-64 account-statements-header-title'>ACCOUNT STATEMENTS</div>
                            <div className='col-sm-12'>
                                <div className='underline-orange'></div>
                            </div>
                        </div>
                        :
                        <div className='col-sm-10 col-sm-offset-1 pt-150'>
                            <div className='font-weight-bold text-center font-64 account-statements-header-title'>SAO KÊ TÀI KHOẢN</div>
                            <div className='col-sm-12'>
                                <div className='underline-orange'></div>
                            </div>
                        </div>
                    }
                    <div className='col-sm-12 flex justify-center pt-50 px-0'>
                        <TripleCustomBreadCrumbs prevPage={t('bread-crumbs.industries')} currentPage={t('bread-crumbs.account-statements')} linkToPrevPage="/industries" />
                    </div>
                </div>


            </div>
            <div className='account-statements-content container'>
                <div className='row flex-lg'>
                    <div className='col-lg-w-400'>
                        <IndustriesStickyMenu bankingAndFinancialActive={true} accountStatementsActive={true} />
                    </div>
                    <div className='col-lg-w--400 account-statements-content_info'>
                        <p className='font-48 font-weight-semibold text-white'>{t('account-statements.title')}</p>
                        <p className='text-white pt-20 font-weight-medium font-20'>{t('account-statements.sub-title')}</p>
                        <p className='text-white pt-20'>{t('account-statements.content-1')}</p>
                        <div className='pt-50'>
                            <img src={account_statements_img1} alt="" className='img-responsive' />
                        </div>
                        <p className='text-white pt-50'>{t('account-statements.content-2')}</p>
                        <div className='pt-50'>
                            <img src={account_statements_img2} alt="" className='img-responsive' />
                        </div>
                        <div className='col-sm-12 pt-50 px-0'>

                            <p className='text-white font-weight-medium'>{t('account-statements.content-3')}</p>
                            <ul className='list-unstyled pt-20'>
                                <li className='checked-line'>{t('account-statements.content-3-1')}</li>
                                <li className='checked-line'>{t('account-statements.content-3-2')}</li>
                                <li className='checked-line'>{t('account-statements.content-3-3')}</li>
                                <li className='checked-line'>{t('account-statements.content-3-4')}</li>
                                <li className='checked-line'>{t('account-statements.content-3-5')}</li>
                                <li className='checked-line'>{t('account-statements.content-3-6')}</li>
                                <li className='checked-line'>{t('account-statements.content-3-7')}</li>
                            </ul>

                        </div>
                        <div className='col-sm-12 pt-30'>
                            <div className='row'>
                                <PrimaryButton
                                onClick={() => setModalDiscussionOpen(true)}
                                >{t('button.schedule-discussion')}</PrimaryButton>
                            </div>
                        </div>
                    </div>
                </div>
                <IndustriesImageContainer />
            </div>

            <Footer />
            {modalDiscussionOpen && <ModalContactDiscussionForm
                setOpenModal={setModalDiscussionOpen}
                handleOverlayClick={handleOverlayClick}
                modalRef={modalDiscussionRef} />}
        </div>
    )
}

export default AccountStatements